import constants_default from '^/components/global/constants';

export default {
  ...constants_default,
  DROPSHIP_WORDING: 'Dropship Only',
}



// WEBPACK FOOTER //
// ./ixcms/themes/heartlandtan/src/vue-src/components/global/constants.js